import "../style/page/dashboard.scss";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { dashboard } from "../../text/apidata";
import axios from "axios";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { Chart } from "react-google-charts";
export default function DashBoard(props) {
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const [dcount, setdcount] = useState(0);
  const [pcount, setpcount] = useState(0);
  const [acount, setacount] = useState(0);
  const [doctorcount, setdoctorcount] = useState(0);
  const [patientcount, setpatientcount] = useState(0);
  const [appoinmentcount, setappoinmentcount] = useState(0);
  const [activitiescount, setactivitiescount] = useState(0);

  const [showPieChart, setShowPieChart] = useState({
    app_count: 0,
    phar_count: 0,
    diag_count: 0,
  });
  console.log(showPieChart, "diag_counr")
  const [pieChartDataAppo, setPieChartDataAppo] = useState({
    pending: 2,
    cancel: 4,
    completed: 2,
  });
  const [pieChartDataPharma, setPieChartDataPharma] = useState({
    confirming_order: 2,
    packing_order: 4,
    in_transit: 2,
    delivered: 2,
  });
  // console.log(doctorcount, patientcount, appoinmentcount);

  // console.log("ghfhdgFHDGF",dcount,pcount,acount)
  var today = new Date();
  var priorDate = new Date();
  var it = convert(today);
  var gt = convert(priorDate);
  // appointment pie chart
  const pie_chart_data = [
    ["Appointment", "count"],
    ["Pending", pieChartDataAppo.pending],
    ["Cancel", pieChartDataAppo.cancel],
    ["Completed", pieChartDataAppo.completed],
  ];
  const options = {
    title: "Appointment status",
    pieHole: 0.5,
    is3D: false,
    slices: {
      //   0: { color: "lite-blue" },
      2: { color: "green" },
    },
  };
  // pie chart for pharma
  const pie_chart_data_pharma = [
    ["Pharmacy", "count"],
    ["Confirming order", pieChartDataPharma.confirming_order],
    ["Packing Order", pieChartDataPharma.packing_order],
    ["In Transit", pieChartDataPharma.in_transit],
    ["Delivered", pieChartDataPharma.delivered],
  ];
  const options_pharma = {
    title: "Pharmacy order status",
    pieHole: 0.5,
    is3D: false,
    slices: {
      1: { color: "grey" },
      3: { color: "green" },
    },
  };
  // pie chart for diagnostics
  const [pieChartDataDia, setPieChartDataDia] = useState({
    confirming_order: 2,
    confirm_the_details: 4,
    en_route: 2,
    samples_collected: 2,
  });
  // for pie chart
  const pie_chart_data_Dia = [
    ["Diagnostics", "count"],
    ["Confirming order", pieChartDataDia.confirming_order],
    ["Confirm the details", pieChartDataDia.confirm_the_details],
    ["En route", pieChartDataDia.en_route],
    ["Samples Collected", pieChartDataDia.samples_collected],
  ];
  // console.log(pie_chart_data,_Dia "pie");
  const options_dia = {
    title: "Diagnostics order status",
    pieHole: 0.5,
    is3D: false,
    slices: {
      //   0: { color: "lite-blue" },
      1: { color: "grey" },
      3: { color: "green" },
    },
  };

  // console.log(it, gt);
  const [range, setrange] = useState([gt, it]);
  // console.log(range, dcount, "777777");
  useEffect(() => {
    props.loaderchange("true");
    axios({
      method: "get",
      url: dashboard,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
      params: {
        date_gt: range[0],
        date_lt: range[1],
      },
    })
      .then((res) => {
        setactivitiescount(0)
        // appointment
        setShowPieChart({
          ...showPieChart,
          ["app_count"]: res.data.data.appoientment_status.appointment_count,
          ["phar_count"]: res.data.data.pharma_status.pharma_count,
          ["diag_count"]: res.data.data.diagnostics_status.diagnostics_count,
        });
        var piedata = {
          pending: res.data.data.appoientment_status.pending,
          cancel: res.data.data.appoientment_status.cancel,
          completed: res.data.data.appoientment_status.completed,
        };
        setPieChartDataAppo(piedata);
        // pharma pie chart
        let status_obtain = {
          confirming_order: res.data.data.pharma_status.confirming_order,
          packing_order: res.data.data.pharma_status.packing_order,
          in_transit: res.data.data.pharma_status.in_transit,
          delivered: res.data.data.pharma_status.delivered,
        };
        setPieChartDataPharma(status_obtain);
        // diagnostics pie chart
        let diagnostics_status = {
          confirming_order: res.data.data.diagnostics_status.confirming_order,
          confirm_the_details:
            res.data.data.diagnostics_status.confirm_the_details,
          en_route: res.data.data.diagnostics_status.en_route,
          samples_collected: res.data.data.diagnostics_status.samples_collected,
        };
        setPieChartDataDia(diagnostics_status);
        console.log(piedata, status_obtain, diagnostics_status, "nirmal");
        setdcount(res.data.data.doctor_count);
        // const intervalId1 = setInterval(() => {
        //   if (res.data.data.doctor_count != 0) {
        //     setdoctorcount((prevCount) => {
        //       if (prevCount < res.data.data.doctor_count) {
        //         return prevCount + 1;
        //       } else {
        //         clearInterval(intervalId1);
        //         return prevCount;
        //       }
        //     });
        //   }
        // });
        setdoctorcount(res.data.data.doctor_count)
        // return() =>{ clearInterval(intervalId1)};
        setpcount(res.data.data.patient_count);
        // const intervalId3 = setInterval(() => {
        //   if (res.data.data.appointment_count != 0) {
        //     setappoinmentcount((prevCount) => {
        //       if (prevCount < res.data.data.appointment_count) {
        //         return prevCount + 1;
        //       } else {
        //         clearInterval(intervalId3);
        //         return prevCount;
        //       }
        //     });
        //   }
        // });
        setappoinmentcount(res.data.data.appointment_count)
        setacount(res.data.data.appointment_count);
        // const intervalId2 = setInterval(() => {
        //   if (res.data.data.patient_count != 0) {
        //     setpatientcount((prevCount) => {
        //       if (prevCount < res.data.data.patient_count) {
        //         return prevCount + 1;
        //       } else {
        //         clearInterval(intervalId2);
        //         return prevCount;
        //       }
        //     });
        //   }
        // });
        setpatientcount(res.data.data.patient_count)
        // const intervalId4 = setInterval(() => {
        //   if (res.data.data.patient_activites != 0) {
        //     setactivitiescount((prevCount) => {
        //       if (prevCount < res.data.data.patient_activites) {
        //         return prevCount + 1;
        //       } else {
        //         clearInterval(intervalId4);
        //         return prevCount;
        //       }
        //     });
        //   }
        // });
        setactivitiescount(res.data.data.patient_activites)
        props.loaderchange("false");
      })
      .catch((error) => {
        console.log(error);
        props.loaderchange("false");
        // setdtPageindex(dtpageindex-1)
        props.popupalert("true");
        props.popuptext("No Data Available");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      });
  }, [range]);

  // useEffect(() => {

  // }, [doctorcount,  dcount]);

  // useEffect(() => {
  //   // return () => clearInterval(intervalId3);
  // }, [  acount,  appoinmentcount]);

  // useEffect(() => {

  //   // return () => clearInterval(intervalId2);
  // }, [  pcount, patientcount]);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const handlechangedate = (name, value) => {
    // let data =value.slice(0, 10)
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };
  const cleaningrange = () => {
    //setrange([gt,it]);
  };
  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },

    {
      label: "Last week",
      closeOverlay: false,
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      appearance: "default",
    },
    {
      label: "Next week",
      closeOverlay: false,
      value: (value, index) => {
        console.log(value);
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
        ];
      },
      appearance: "default",
    },
  ];

  return (
    <>
      <div className={sideactive ? "dashboard-main-sa" : "dashboard-main"}>
        <div class="page-header">
          <div class="row">
            <div class="col-sm-12">
              <h3 class="page-title">
                {"Welcome " + localStorage.getItem("role") + "!"}
              </h3>
              <ul
                class="breadcrumb"
                style={{ justifyContent: "space-between" }}
              >
                <li class="breadcrumb-item active">Dashboard</li>
                <li>
                  {" "}
                  <div className="datepicker_dash">
                    <DateRangePicker
                      defaultValue={[
                        new Date(),
                        new Date(),
                      ]}
                      disabledDate={(date) => isAfter(date, new Date())}
                      editable={false}
                      appearance="default"
                      placement="bottomEnd"
                      size="lg"
                      ranges={predefinedBottomRanges}
                      placeholder="From - To"
                      style={{ width: 270, padding: 10 }}
                      onClean={(e) => cleaningrange(e)}
                      onChange={(e) => {
                        if (e != null) {
                          setrange([]);
                          setdoctorcount(0);
                          setpatientcount(0);
                          setappoinmentcount(0);
                          setactivitiescount(0);
                          e.forEach((newValue) => {
                            var tzoffset =
                              new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                            var localISOTime = new Date(newValue - tzoffset)
                              .toISOString()
                              .slice(0, -1);
                            handlechangedate("validtill", localISOTime);
                          });
                        }
                      }}
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-4 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-primary border-primary">
                    <i class="bi bi-person-fill-add"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{doctorcount}</h3>
                    {/* <h3>{ dcount}</h3> */}
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Doctors</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-primary"
                      role="progressbar"
                      style={{ width: `${doctorcount / 10}px` }}
                      aria-valuenow={doctorcount}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-success">
                    <i class="bi bi-person-bounding-box"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{patientcount}</h3>
                    {/* <h3>{pcount}</h3> */}
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Patients</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-success"
                      style={{ width: `${patientcount / 10}px` }}
                      aria-valuenow={patientcount}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-danger border-danger">
                    <i class="bi bi-person-vcard-fill"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{appoinmentcount}</h3>
                    {/* <h3>{acount}</h3> */}
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Appointment</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-danger"
                      style={{ width: `${appoinmentcount / 10}px` }}
                      aria-valuenow={appoinmentcount}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-success border-success">
                    <i class="bi bi-activity"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{activitiescount}</h3>
                    {/* <h3>{acount}</h3> */}
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Activities</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-success"
                      style={{ width: `${activitiescount / 10}px` }}
                      aria-valuenow={activitiescount}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {showPieChart.app_count > 0 &&
            <div className="col-xl-4 col-sm-6 col-12 ">
              <div class="card">
                <Chart
                  chartType="PieChart"
                  data={pie_chart_data}
                  options={options}
                  width={"400px"}
                  height={"290px"}
                />
              </div>
            </div>
          }
          {
            showPieChart.phar_count > 0 &&
            <div className="col-xl-4 col-sm-6 col-12 ">
              <div class="card">
                <Chart
                  chartType="PieChart"
                  data={pie_chart_data_pharma}
                  options={options_pharma}
                  width={"400px"}
                  height={"290px"}
                />
              </div>
            </div>
          }
          {
            showPieChart.diag_count > 0 &&
            <div className="col-xl-4 col-sm-6 col-12 ">
              <div class="card">
                <Chart
                  chartType="PieChart"
                  data={pie_chart_data_Dia}
                  options={options_dia}
                  width={"400px"}
                  height={"290px"}
                />
              </div>
            </div>
          }

        </div>
      </div>
    </>
  );
}
